module.exports = __webpack_public_path__ + "static/media/Larioja.986e67b2.svg";